import Page from "@shared/pages/homepage";

export default Page;
